import { createGlobalStyle } from 'styled-components';
import 'normalize.css';
import color from './colors';
import { respondTo } from './helper';

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-all;
    word-break: break-word;
    hyphens: auto;
  }
  html,
  body {
    padding: 0;
    margin: 0;
    color: ${color.white};
    font-family: 'Graphik', -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu,
    Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
  }

  body {
    height: 100vh;
    background: ${({ theme }) => theme?.colors?.body};
  }

  a {
    display: inherit;
    color: inherit;
    text-decoration: none;
  }

  main {
    height: 80vh;
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding-top: 1.5rem;
    margin: 0 1.5rem;
    ${respondTo.bp_767`  
      padding-top: 3.5rem;
    `}
  }
`;

export default GlobalStyle;
